import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  Autocomplete,
  LinearProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import axios from '../../axiosConfig';
import './animation.css';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: '#424242',
  fontWeight: '600',
});

const RateCard = () => {
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  // INPUT FIELD STATES
  const [rateData, setRateData] = useState([]);
  const [operation, setOperation] = useState('Add');
  const [OperationData, setOperationData] = useState([]);
  const [selectedOperation, setselectedOperation] = useState(null);
  const [empRole, setEmpRole] = useState('O');
  const [RateOnMale, setRateOnMale] = useState('');
  const [RateOnFeMale, setRateOnFeMale] = useState('');
  const [Active, setActive] = useState('Y');

  // HANDLE CRUD STATES
  const [IdToDelete, setIdToDelete] = useState(null);
  const [editID, setEditID] = useState();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  // ERROR STATES
  const [errors, setErrors] = useState({
    OperationId: false,
    empRole: false,
    RateOnMale: false,
    RateOnFeMale: false,
    Active: false,
  });

  // ERROR MESSAGE STATES
  const [helperTexts, setHelperTexts] = useState({
    OperationId: '',
    empRole: '',
    RateOnMale: '',
    RateOnFeMale: '',
    Active: '',
  });

  // OTHER ACTIONS
  const [alertType, setAlertType] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [openAlert, setopenAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [openLoader, setOpenLoader] = useState(false);

  const resetFields = () => {
    setselectedOperation(null);
    setEmpRole('O');
    setRateOnMale('');
    setRateOnFeMale('');
    setActive('Y');

    errors.OperationId = false;
    errors.empRole = false;
    errors.RateOnMale = false;
    errors.RateOnFeMale = false;
    errors.Active = false;

    helperTexts.OperationId = '';
    helperTexts.empRole = '';
    helperTexts.RateOnMale = '';
    helperTexts.RateOnFeMale = '';
    helperTexts.Active = '';
  };

  // API Integration
  useEffect(() => {
    GetAllActiveOperationMstData();
    GetAllRateCardMst();
  }, []);

  // get all operations
  const GetAllRateCardMst = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllRateCardMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setRateData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all operations
  const GetAllActiveOperationMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperationData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Add new record
  const addNewOperation = async (newData) => {
    try {
      const res = await axios.instance.post('/InsertRateCardMstData', newData, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      GetAllRateCardMst();
      setAlertType('success');
      setAlertMessage(operation === 'Edit' ? 'Rate Card updated Successfully!' : 'New Rate Card Added Successfully!');
      setopenAlert(true);
      resetFields();
    } catch (error) {
      console.error('Error adding opName:', error);
      setAlertType('error');
      setAlertMessage(operation === 'Edit' ? 'Failed to Update the Rate Card!' : 'Failed to add the Rate Card!');
      setopenAlert(true);
    }
  };

  // to delete record
  const deleteOperation = async (id2) => {
    try {
      await axios.instance
        .delete(`/DeleteRateCardMst/${id2}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            GetAllRateCardMst();
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage('Rate Card Deleted Successfully!');
            setopenAlert(true);
          } else {
            GetAllRateCardMst();
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
          console.log(res.data);
        });
    } catch (error) {
      console.error('Error deleting Rate Card:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the Rate Card.');
      setopenAlert(true);
    }
  };

  // submit button on add or edit
  const handleSubmit = (event) => {
    event.preventDefault();

    const inputValidation =
      errors.OperationId ||
      errors.empRole ||
      errors.RateOnMale ||
      errors.RateOnFeMale ||
      errors.Active ||
      !empRole ||
      !RateOnFeMale ||
      !RateOnFeMale ||
      !Active ||
      !selectedOperation ||
      selectedOperation === null ||
      selectedOperation === 0 ||
      selectedOperation === undefined ||
      selectedOperation === '';

    if (inputValidation) {
      if (!selectedOperation) {
        setErrors((prevErrors) => ({ ...prevErrors, OperationId: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          OperationId: 'please select operation ',
        }));
      }
      if (!RateOnMale) {
        setErrors((prevErrors) => ({ ...prevErrors, RateOnMale: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          RateOnMale: 'please select pcs rate on male',
        }));
      }
      if (!RateOnFeMale) {
        setErrors((prevErrors) => ({ ...prevErrors, RateOnFeMale: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          RateOnFeMale: 'please select pcs rate on female',
        }));
      }
      if (!empRole) {
        setErrors((prevErrors) => ({ ...prevErrors, emp_role: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          emp_role: 'please select employee role',
        }));
      }
      if (!Active) {
        setErrors((prevErrors) => ({ ...prevErrors, Active: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Active: 'please select active status',
        }));
      }
    }

    if (inputValidation) {
      return;
    }

    const newAddData = {
      optype: operation === 'Edit' ? 'Edit' : 'Add',
      rateId: operation === 'Edit' ? editID : '',
      OperationId: selectedOperation.OperationId,
      role_emp: empRole,
      RateOnMale,
      RateOnFeMale,
      Active,
      [operation === 'Edit' ? 'ModifyedBy' : 'CreatedBy']: sessionStorage.getItem('UserID'),
    };
    addNewOperation(newAddData);
    resetFields();
    handleClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setRateOnFeMale(event.target.value)
    const numericFields = ['RateOnMale', 'RateOnFeMale'];

    
    if (numericFields.includes(name) && !/^\d*$/.test(value)) {
      return; 
    }
    if (name === 'RateOnMale') setRateOnMale(value);
    if (name === 'RateOnFeMale') setRateOnFeMale(value);
    if (name === 'empRole') setEmpRole(value);
    if (name === 'Active') setActive(value);
    validateInput(name, value);
  };

  const handleInputChangeSelect = (event, newValue) => {
    const editedData = newValue.OperationId;
    const isDataExistsinEDIt = rateData.some((obj) => obj.OperationId === editedData && obj.rateId !== editID);
    const isDataExists = rateData.some((obj) => obj.OperationId === editedData);

    setselectedOperation(newValue);
    setEmpRole(newValue.emp_role);

    if (!newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, OperationId: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, OperationId: 'please select operation' }));
    } else if (operation === 'Add' && isDataExists) {
      setErrors((prevErrors) => ({ ...prevErrors, OperationId: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, OperationId: 'Opeartion Record already exists' }));
    } else if (operation === 'Edit' && isDataExistsinEDIt) {
      setErrors((prevErrors) => ({ ...prevErrors, OperationId: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, OperationId: 'Opeartion Record already exists' }));
      setIsFormSubmitted(false);
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, OperationId: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, OperationId: '' }));
    }
  };

  // validations
  const validateInput = (name, value) => {
    let error = false;
    let helperText = '';

    const validateField = (fieldName, errorMsg) => {
      if (!value.trim()) {
        error = true;
        helperText = errorMsg;
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    };

    switch (name) {
      case 'RateOnMale':
        validateField(name, 'male rate on pcs cannot be empty');
        break;
      case 'RateOnFeMale':
        validateField(name, 'female rate on pcs cannot be empty');
        break;
      default:
        break;
    }

    // Update the errors and helperTexts states correctly
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      [name]: helperText,
    }));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (value.length > 0) {
      validateInput(name, value);
    }
  };

  // handle edit popup dialog
  const handleAddOpen = () => {
    setOpen(true);
    setOperation('Add');
  };

  // handle edit popup dialog
  const handleEdit = (data) => {
    setEditID(data.rateId);
    const selectedObj = OperationData.find((obj) => obj.OperationId === data.OperationId);
    setselectedOperation(selectedObj);
    setEmpRole(data.role_emp);
    setRateOnMale(data.RateOnMale);
    setRateOnFeMale(data.RateOnFeMale);
    setActive(data.Active);
    handleEditOpen();
  };

  const handleEditOpen = () => {
    setOpen(true);
    setOperation('Edit');
  };

  // handle edit popup dialog
  const handleDelete = (stateId) => {
    setOpenDelete(true);
    setIdToDelete(stateId);
  };

  const handleDeleteConfirmed = (stateId) => {
    deleteOperation(stateId);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleClose = () => {
    setOpen(false);
    resetFields();
  };

  // search & filter
  const filteredData = rateData.filter((c) => c.OperationName.toLowerCase().includes(searchTerm.toLowerCase()));

  // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1));
  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #314755, #26a0da)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Rate Card Master
            </Typography>
          </Typography>
        </Grid>

        {/* search & add button */}
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={2} my={2}>
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <Button
            variant="outlined"
            color="secondary"
            sx={{ boxShadow: 1 }}
            onClick={handleAddOpen}
            startIcon={<AddLocationAltRoundedIcon />}
          >
            Add Rate Card
          </Button>
        </Stack>

        {/* table  */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Operation</StyledTableCell>
                <StyledTableCell align="left">O/P Type</StyledTableCell>
                <StyledTableCell align="left">Rate/Pcs-Male </StyledTableCell>
                <StyledTableCell align="left">Rate/Pcs-Female</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredData
              ).map((obj, index) => (
                <TableRow key={index} hover>
                  <TableCell align="center">{obj.SNo}</TableCell>
                  <TableCell align="left">{obj.OperationName}</TableCell>
                  <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                    {obj.role_emp === 'O' ? 'Operator' : 'Helper'}
                  </TableCell>
                  <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                    {obj.RateOnMale}
                  </TableCell>
                  <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                    {obj.RateOnFeMale}
                  </TableCell>
                  <TableCell align="center">
                    {obj.Active === 'Y' ? (
                      <Chip icon={<CheckCircleOutlineIcon />} color="success" size="small" label="Active" />
                    ) : (
                      <Chip icon={<HighlightOffIcon />} color="error" size="small" label="InActive" />
                    )}
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton aria-label="Edit" onClick={() => handleEdit(obj)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton aria-label="Delete" onClick={() => handleDelete(obj.rateId)}>
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={5} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          mt={2}
        />
      </Container>

      <Grid m={2}>
        {/* add new popup form dialog box */}
        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} fullWidth>
          <Container component={Paper} elevation={2} sx={{ py: 2 }}>
            <form onSubmit={handleSubmit} noValidate>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h5" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {operation} Rate Card
                </Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Grid container spacing={2} p={2}>
                <Grid item xs={12}>
                  <Autocomplete
                    size="small"
                    name="group"
                    options={OperationData}
                    getOptionLabel={(obj) => (obj ? obj.OperationName : '')}
                    value={selectedOperation || null}
                    onChange={handleInputChangeSelect}
                    renderInput={(params) => <TextField {...params} label="Select Operation" required/>}
                  />
                  {errors.OperationId && (
                    <Typography
                      variant="caption"
                      color="error"
                      className={isFormSubmitted && errors.OperationId ? 'shake-helper-text' : ''}
                    >
                      {errors.OperationId && helperTexts.OperationId}
                    </Typography>
                  )}
                </Grid>
                <Grid item md={6}>
                  <TextField
                    type="text"
                    variant="outlined"
                    color="primary"
                    label="Rate/Pcs-Male"
                    name="RateOnMale"
                    value={RateOnMale}
                    onBlur={handleBlur}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    size="small"
                    error={errors.RateOnMale}
                    helperText={helperTexts.RateOnMale}
                    className={isFormSubmitted && errors.RateOnMale ? 'shake-helper-text' : ''}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    type="text"
                    variant="outlined"
                    color="primary"
                    label="Rate/Pcs-Female"
                    name="RateOnFeMale"
                    value={RateOnFeMale}
                    onBlur={handleBlur}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    size="small"
                    error={errors.RateOnFeMale}
                    helperText={helperTexts.RateOnFeMale}
                    className={isFormSubmitted && errors.RateOnFeMale ? 'shake-helper-text' : ''}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl size="small" fullWidth component="fieldset" name="empRole">
                    <FormLabel component="legend">O/P Type</FormLabel>
                    <RadioGroup row value={empRole} name="empRole" onChange={handleInputChange}>
                      <FormControlLabel value="O" control={<Radio />} label="Operator" />
                      <FormControlLabel value="H" control={<Radio />} label="Helper" />
                    </RadioGroup>
                    {errors.empRole && (
                      <Typography
                        variant="caption"
                        color="error"
                        className={isFormSubmitted && errors.empRole ? 'shake-helper-text' : ''}
                      >
                        {errors.empRole && helperTexts.empRole}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl size="small" fullWidth component="fieldset" name="active">
                    <FormLabel component="legend">Active Status</FormLabel>
                    <RadioGroup row value={Active} name="Active" onChange={handleInputChange}>
                      <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                      <FormControlLabel value="N" control={<Radio />} label="No" />
                    </RadioGroup>
                    {errors.Active && (
                      <Typography
                        variant="caption"
                        color="error"
                        className={isFormSubmitted && errors.Active ? 'shake-helper-text' : ''}
                      >
                        {errors.Active && helperTexts.Active}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    size="small"
                    color="primary"
                    type="submit"
                    sx={{ textTransform: 'capitalize' }}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Container>
        </Dialog>

        {/* delete confirmation popup dialog box */}
        <Dialog
          open={openDelete}
          onClose={handleCloseDelete}
          aria-labelledby="alert-dialog-title"
          fullScreen={fullScreen}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">{'Are you sure want to Delete?'}</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={() => handleDeleteConfirmed(IdToDelete)} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
      {/* /* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default RateCard;
